import React from 'react';
import { FormSelect, FormMultiSelect, FormAsyncSelect, FormAsyncMultiSelect } from 'shared/formControls';
import { useSelector } from 'react-redux';
import { getDispatchers } from 'src/slices/dispatchers';
import { getDispatchers as getDispatchersLookup } from 'src/fetch/dispatching';

const DATA_ITEM_KEY = 'id';
const TEXT_FIELD = 'displayName';

const DispatchersDropdown = ({ multiSelect, ...props }) => {
  const dispatchers = useSelector(getDispatchers);
  const SelectComponent = multiSelect ? FormMultiSelect : FormSelect;
  return (
    <SelectComponent
      data={dispatchers}
      dataItemKey={DATA_ITEM_KEY}
      textField={TEXT_FIELD}
      clearButton
      {...props}
    />
  );
};

const getDataBySearch = (search) => getDispatchersLookup({ search });

export const DispatchersAsyncSelect = (props) => (
  <FormAsyncSelect getData={getDataBySearch} dataItemKey={DATA_ITEM_KEY} textField={TEXT_FIELD} {...props} />
);

export const DispatchersAsyncMultiSelect = (props) => (
  <FormAsyncMultiSelect getData={getDataBySearch} dataItemKey={DATA_ITEM_KEY} textField={TEXT_FIELD} {...props} />
);

export default DispatchersDropdown;